export const clientRTTI = Symbol.for("Client");
export const clientProviderRTTI = Symbol.for("ClientProvider");
export const clientSettingsRTTI = Symbol.for("ClientSettings");
export const clientMockOptionsRTTI = Symbol.for("ClientMockOptions");
